import { INDEX_COLORS } from './constants/util-benchmark-constants';

export const getBenchmarkColor = (benchmark: string): string => {
  const color = INDEX_COLORS[benchmark];

  return color || '#000';
};
